import MAccordion from "@mui/material/Accordion";
import MAccordionDetails from "@mui/material/AccordionDetails";
import MAccordionSummary, { accordionSummaryClasses } from "@mui/material/AccordionSummary";
import MCard from "@mui/material/Card";
import MCardContent from "@mui/material/CardContent";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const Accordion = styled(MAccordion, {
  shouldForwardProp(propName) {
    return propName !== "block";
  },
})<{ block?: boolean }>(({ block, theme }) => ({
  width: block ? "100%" : undefined,
  borderRadius: "12px",
  "&:before": {
    display: "none",
  },

  [theme.breakpoints.down("md")]: {
    borderRadius: "0px !important",
  },
}));

const AccordionSummary = styled(MAccordionSummary)(() => ({
  padding: "24px",
  [`& .${accordionSummaryClasses.content}`]: {
    margin: 0,
  },
}));

const AccordionDetails = styled(MAccordionDetails)(() => ({
  padding: "24px",
  paddingTop: 0,
  paddingBottom: 0,
}));

const Card = styled(MCard, {
  shouldForwardProp(propName) {
    return !["block", "fullHeight"].includes(propName as string);
  },
})<{ block?: boolean; fullHeight?: boolean }>(({ block, fullHeight, theme }) => ({
  justifyContent: "flex-start",
  width: block ? "100%" : undefined,
  [theme.breakpoints.down("md")]: {
    borderRadius: 0,
  },
  height: fullHeight ? "100%" : undefined,
}));

const CardTitle = styled(Typography)(() => ({
  fontSize: 22,
  fontWeight: 600,
  lineHeight: "28px",
  display: "flex",
  alignItems: "center",
}));

interface ICardContent {
  fullHeight?: boolean;
  justifyContent?: string;
}
const CardContent = styled(MCardContent, {
  shouldForwardProp(propName) {
    return !["fullHeight", "justifyContent"].includes(propName as string);
  },
})(({ fullHeight, justifyContent }: ICardContent) => ({
  display: "flex",
  flexDirection: "column",
  padding: "24px",
  justifyContent: justifyContent ?? "flex-start",
  gap: "24px",
  height: fullHeight ? "100%" : undefined,
}));

export { Accordion, AccordionDetails, AccordionSummary, Card, CardTitle, CardContent };
